import gql from 'graphql-tag';

const getAssetSummariesAndCount = gql`
  query GetAssetSummariesAndCount(
    $organisationId: String,
    $search: String,
    $createdBy: [String],
    $createdAt: [String],
    $fileType: [String],
    $isArchived: Boolean,
    $assetFileTypes: [AssetType],
    $offset: Int,
    $limit: Int,
    $sortBy: [String]
    $tagIds: [ID]
    ) {
    getAssetSummariesAndCount(
      organisationId: $organisationId,
      search: $search,
      createdBy: $createdBy,
      createdAt: $createdAt,
      fileType: $fileType,
      isArchived: $isArchived,
      assetFileTypes: $assetFileTypes,
      offset: $offset,
      limit: $limit,
      sortBy: $sortBy,
      tagIds: $tagIds,
      ) {
      count
      assets {
        assetId
        organisationId
        filename
        title
        description
        tags
        altText
        metaData
        createdAt
        updatedAt
        permissions
        archivedAt
        folders {
          tagId
        }
        createdByUser {
          firstName,
          lastName
        }
        updatedByUser {
          firstName,
          lastName
        }
        assetFiles {
          ORIGINAL {
            assetFileId
            type
            status
            sourceUrl
          }
          THUMBNAIL {
            assetFileId
            type
            status
            sourceUrl
          }
        }
      }
    }
  }
`;

export default ((organisationId) => ({
  query: getAssetSummariesAndCount,
  module: 'assets',
  ignoreCache: true,
  buildVariables: ({
    offset,
    limit,
    search,
    createdBy,
    createdAt,
    fileType,
    isArchived,
    sortBy,
    tagIds










  }) => ({
    organisationId,
    limit,
    offset,
    search,
    createdBy,
    createdAt,
    fileType,
    isArchived,
    sortBy,
    tagIds,
    assetFileTypes: ['THUMBNAIL']
  })
}));